import { render, staticRenderFns } from "./UcInvoiceLineGroup.yaml?vue&type=template&id=c2ee8ea0&component"
import script from "./UcInvoiceLineGroup.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceLineGroup.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports